import { InjectionToken } from '@angular/core';

export type BottomSheetData<T = undefined> = {
  data: T;
};

export const BOTTOM_SHEET_DATA = new InjectionToken('bottom-sheet-data');
